import type { ConfigType } from '@plone/registry';
import FilterWidget, {
  FilterWidgetProps,
} from '../components/Widgets/FilterWidget/FilterWidget';
import FormatWidget from '../components/Widgets/FormatWidget/FormatWidget';
import TextlinesWidget from '../components/Widgets/TextlinesWidget/TextlinesWidget';
import CustomObjectWidget from '../components/Widgets/CustomObjectWidget/CustomObjectWidget';
import CustomObjectListWidget from '../components/Widgets/CustomObjectListWidget/CustomObjectListWidget';
import FocusPointWidget from '../components/Widgets/FocusPointWidget/FocusPointWidget';
import IconWidget from '../components/Widgets/IconWidget/IconWidget';
import CheckboxWidget from '@plone/volto/components/manage/Widgets/CheckboxWidget';
import AnchorWidget, {
  AnchorWidgetProps,
} from '../components/Widgets/Anchor/AnchorWidget';
import QuerySortingSelectionWidget from '@fhnw/components/Widgets/QuerySortingSelectionWidget/QuerySortingSelectionWidget';

/**
 * Configure all custom widgets
 * Applies SOLID principles by separating widget configuration concerns
 */
export const configureWidgets = (config: ConfigType) => {
  // Widget configuration following Single Responsibility Principle
  config.widgets.widget.filter_widget =
    FilterWidget as React.FC<FilterWidgetProps>;
  config.widgets.widget.format_widget = FormatWidget;
  config.widgets.widget.textlines_widget = TextlinesWidget;
  config.widgets.widget.custom_object_widget = CustomObjectWidget;
  config.widgets.widget.custom_object_list_widget = CustomObjectListWidget;
  config.widgets.widget.anchor =
    AnchorWidget as React.ComponentType<AnchorWidgetProps>;
  (config.widgets.widget as any).checkbox = CheckboxWidget;
  config.widgets.widget.icon_widget = IconWidget;
  config.widgets.widget.focus_point_widget = FocusPointWidget;
  config.widgets.widget.query_sorting_selection_widget =
    QuerySortingSelectionWidget;

  return config;
};
